import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
// import "./index.scss";
import { Modal, Offcanvas } from "react-bootstrap";
import backicon from "../../../../../Assets/icons/backIcon.svg";
import axiosInstance from "../../../../services/api/API";
import moment from "moment";
import viewIcon from '../../../../../Assets/icons/eye 1.svg';
import "bootstrap/dist/css/bootstrap.min.css";
// import AddIssueDynemicForm from "../../addIssueDynemicFrom";
import ReactSignatureCanvas from "react-signature-canvas";
import AddIssueDynemicForm from "../../../Services/addIssueDynemicFrom";
import SalesDynamicForm from "../../SalesComponents/SalesDynamicform";

const InvoiceDetails = () => {
  const location = useLocation();

  // const [ formData, setFormData ]

  const { data } = location?.state || {};
  const navigate = useNavigate();
  const [jobCardDetails, setJobCardDetails] = useState([]);
  const [personalDetails, setPersonalDetails] = useState(null);
  const [modalType, setModalType] = useState(null);
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const [complainList, setComplainList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [signatureModel, setSignatureModel] = useState(false);
  const [UpdateModel, setUpdateModel] = useState(false);
  const [editIssueData, setEditIssueData] = useState();
  const [paybleTotalAmount, setPaybleTotalAmount] = useState(null);
  const [transactionDetails, setTransactionDetails] = useState([]); 
  const [totalTransaction_Amount,setTotalTransaction_Amount] =useState(null);// Add state for remark
  const [ inVoiceIdValue , setInVoiceIdValue ] = useState("")

  const [ paymentHistory , setPaymentHistory ] = useState([])

  const [ totalAmountValue , setTotalAmount ] = useState(0)

  const [issueId, setIssueId] = useState(0);
  const [addModel, setAddModel] = useState(false);
  const bussness_id = data?.business_partner_id;
  const job_Card_id = data?.job_card_id;

  const [ pendingAmount , setPendingAmount ] = useState(0)
  const [ totalAmountVal , setTotalAmountVal ] = useState(0)
  const [ totalTransAmount , setTotalTranAmount ] = useState(0)

  const [ showParentDesignation, setShowParentDesignation ] = useState(true)



  const invoiceId  = data.invoice_id
  console.log(invoiceId, "invoiceIdValue")

  const sigCanvas = useRef();
  const IssueInputs = [
    {
      name: "Payment_mode",
      label: "Payment Mode",
      type: "dropdown",
      placeholder: "Enter Complain Description",
      required: true,
      options: [
        {
          label: "Online",
          value: 3,
        },
        {
          label: "Cash",
          value: 1,
        },
      ],
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
      },
      disabled: false,
      // isVisible: false
    },
    {
      name: "transaction_amount",
      label: "Transaction Amount",
      type: "text",
      placeholder: "Enter Transaction Amount",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: {
        required: true,
      },
    },

    {
      name: "transaction_date",
      label: "Transaction Date",
      type: "date",
      // placeholder: "Enter Estimate Cost",
      required: true,
      gridClass: "col-lg-12 mb-3",
      validation: { required: true },
    },
    {
      name: "deliverydate",
      label: "Delivery Date",
      type: "date",
      // placeholder: "Enter Estimate Cost",
      required: true,
      gridClass: "col-lg-12 mb-3",
      // validation: {
      //   required: true,
      // },
      isVisible: showParentDesignation,
    },
    {
      name: "deliveryremark",
      label: "Delivery Remark",
      type: "text",
      placeholder: "Enter Daily Remark",
      required: true,
      gridClass: "col-lg-12 mb-3",
      // validation: {
      //   required: true,
      // },
      isVisible: showParentDesignation,
    },
    {
      name: "receiptFile",
      label: "Receipt",
      type: "agentfile",
      placeholder: "Enter Estimate Cost",
      required: true,
      gridClass: "col-lg-12 mb-3",
      // validation: { required: true },
      isVisible: true,
    },
  ];

  const onClickSetIssueId = (id) => {
    if (id == "") {
      setIssueId("");
    } else {
      setIssueId(id);
    }
  };

  useEffect(() => {
    fetchInvoiceDetails()
  },[])

  // useEffect(() => {
  //   const formattedPendingAmount = parseFloat(pendingAmount.replace(/₹|,/g, ''));
  
  //   if (Number(formData.transaction_amount) === formattedPendingAmount) {
  //     setShowParentDesignation(true); // Show delivery fields when amount matches
  //   } else {
  //     setShowParentDesignation(false); // Hide delivery fields otherwise
  //   }
  // }, [formData.transaction_amount, pendingAmount]);

  useEffect(() => {
    let formattedPendingAmount = 0;
  
    if (typeof pendingAmount === 'string') {
      // Convert pendingAmount to a number by removing currency symbol and commas if it's a string
      formattedPendingAmount = parseFloat(pendingAmount.replace(/₹|,/g, ''));
    } else if (typeof pendingAmount === 'number') {
      // If pendingAmount is already a number, use it as-is
      formattedPendingAmount = pendingAmount;
    }
  
    // Compare transaction_amount with formattedPendingAmount
    if (Number(formData.transaction_amount) === formattedPendingAmount) {
      setShowParentDesignation(true); // Show delivery fields when amount matches
    } else {
      setShowParentDesignation(false); // Hide delivery fields otherwise
    }
  }, [formData.transaction_amount, pendingAmount]);

  const fetchInvoiceDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "/salesreceiptpayment/list",
        {

          orderBy: "salespayment_id DESC",
          invoice_id: data.invoice_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data?.datares ;

      const finalData = response.data.data
      console.log(finalData, "FINALDATA")

      setPendingAmount(finalData.pendingAmount)
      setTotalAmountVal(finalData.totalAmount)
      setTotalTranAmount(finalData.totalTranAmount)


      setPaymentHistory(formattedData)
      console.log(formattedData, "formatedDataTable")
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  useEffect(() => {
    fetchProposalDetails()
   
  },[])

  const fetchProposalDetails = async (page = 0, pageSize = 1) => {
    try {
      const response = await axiosInstance.post(
        "proposal/getproposalview",
        {

          business_partner_id: 1,
          proposal_id:data.proposal_id
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const formattedData = response?.data?.data[0];
      console.log(formattedData, "formatedData")

      const totalAmount = formattedData.balance_amount - formattedData.tax_amount

      console.log(totalAmount, "totalAmount")
      setTotalAmount(totalAmount)

      setPersonalDetails(formattedData)

      // setPaybleTotalAmount(response?.data?.data);
      // setComplainList(formattedData);
    } catch (error) {
      console.error("Error fetching business partners:", error);
    }
  };

  const handleFormSubmit = async (data) => {
    const errors = {};
    let isValid = true;
  
    // Validation logic
    IssueInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!data[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        }
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(data[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
  
    // Declare formData after validation is complete
    const formData = new FormData();
  
    // Append form data
    formData.append("onboard_bp_id", 1);
    formData.append("invoice_id", invoiceId);
    formData.append("transaction_amount", data?.transaction_amount);
    formData.append("deliverydate", moment(data?.deliverydate).format("YYYY-MM-DD"));
    formData.append("deliveryremark", data?.deliveryremark);
    formData.append(
      "transaction_date",
      moment(data?.transaction_date).format("YYYY-MM-DD")
    );
  
    // Conditionally append receiptFile if Payment_mode is 3
    if (data?.Payment_mode === 3 && data?.receiptFile) {
      formData.append("receiptFile", data?.receiptFile);
    }
    
    // Append payment_mode_id
    formData.append("payment_mode_id", data?.Payment_mode);
  
    console.log("clicked");
  
    try {
      let response;
  
      // Conditionally call API based on Payment Mode
      if (data?.Payment_mode === 3) {  // Online payment
        response = await axiosInstance.post(
          "salesreceiptpayment/createOnlinePayment",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else if (data?.Payment_mode === 1) {  // Cash payment
        response = await axiosInstance.post(
          "salesreceiptpayment/createOfflinePayment",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }
  
      // Handle response
      if (response?.status) {
        handleClose()
        fetchInvoiceDetails()
      }
    } catch (error) {
      console.error("Error during payment submission:", error);
    }
  };
  

  const handleClose = () => {
    setUpdateModel(false);
  };

  // useEffect(() => {
  //   if (data) {
  //     // fetchJobCardIssueList();
  //     // fetchJobCardDetails();
  //     fetchComplainList();
  //   }
  // }, [data]);



    const backNavigate = () => {
    navigate("/manage-sales/invoice");
  };

  
  return (
    <div className="container-fuiled">
      <div className="OnboardManagamentContainer  mt-2 mb-2">
        <span className="backbtntitle">
          {" "}
          <img src={backicon} alt="back" style={{ marginRight: 5 }} onClick={()=>backNavigate()}/> Payment
          Invoice Details
        </span>
        <div className="gap-5">
        {/* {totalTransaction_Amount?.totalPaidAmount !== 0 && ( */}
        {/* {personalDetails?.payment_status ===0&&( */}
        <button 
        className="addcustomerbutton "
            onClick={() => setUpdateModel(true)}
        >
          Update
        </button>
          {/* )} */}
        </div>
    
      </div>
      <div className="container-fuiled row   ">
        <div className="col-md-6 vechalDetails">
          <div>
            <h5 className="m-3">Personal Details</h5>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Customer Name</span>
                  <span className="details-value">
                    {personalDetails?.customer_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Mobile Name</span>
                  <span className="details-value">
                    {personalDetails?.mobile_no || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Address</span>
                  <span className="details-value">
                    {personalDetails?.address || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">City Name</span>
                  <span className="details-value">
                    {personalDetails?.city_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">State Name</span>
                  <span className="details-value">
                    {personalDetails?.state_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Email Id</span>
                  <span className="details-value">
                    {personalDetails?.email_id || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">PIN Code</span>
                  <span className="details-value">
                    {personalDetails?.pincode || "-"}
                  </span>
                </div>

                {/* <div className="details-item">
                  <span className="details-label">Address</span>
                  <span className="details-value">
                    {personalDetails?.address || "-"}
                  </span>
                </div> */}
                <div className="details-item">
                  <span className="details-label">Address</span>
                  <span className="details-value">
                    {personalDetails?.address
                      ? personalDetails.address.length > 40
                        ? `${personalDetails.address.substring(0, 50)}...`
                        : personalDetails.address
                      : "-"}
                  </span>
                </div>
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Vehicle Details</h5>
            </div>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Product</span>
                  <span className="details-value">
                    {personalDetails?.product_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Sub Product</span>
                  <span className="details-value">
                    {personalDetails?.subproduct_name || ""}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Make</span>
                  <span className="details-value">
                    {personalDetails?.make_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Model</span>
                  <span className="details-value">
                    {personalDetails?.model_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Variant</span>
                  <span className="details-value">
                    {personalDetails?.variant_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Color</span>
                  <span className="details-value">
                    {personalDetails?.color_name || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Fuel Type</span>
                  <span className="details-value">
                    {personalDetails?.fuel_type_name || "-"}
                  </span>
                </div>
                
              </div>
            </div>
            <br />
            <div className="borderWidth">
              <h5 className="m-3">Quotation Details</h5>
            </div>
            <div className="mt-3 m-3">
              <div className="invoice-vechal-Details-SubView">
                <div className="details-item">
                  <span className="details-label">Quotation Dates</span>
                  <span className="details-value">
                    {personalDetails?.quotation_date || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Quotation Code</span>
                  <span className="details-value">
                    {personalDetails?.quotationCode || ""}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Ex Showroom Price</span>
                  <span className="details-value">
                    {personalDetails?.exshowroom_price || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Plate Charges</span>
                  <span className="details-value">
                    {personalDetails?.plate_charges || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Insurance</span>
                  <span className="details-value">
                    {personalDetails?.insurance || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">RTO Amount</span>
                  <span className="details-value">
                    {personalDetails?.rto_amount || "-"}
                  </span>
                </div>
                <div className="details-item">
                  <span className="details-label">Accessory Cost</span>
                  <span className="details-value">
                    {personalDetails?.accessory_cost || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Discount Type</span>
                  <span className="details-value">
                    {personalDetails?.discount_type || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Discount</span>
                  <span className="details-value">
                    {personalDetails?.discount || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">On Road Price</span>
                  <span className="details-value">
                    {personalDetails?.onroad_price || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Payable Amount</span>
                  <span className="details-value">
                    {personalDetails?.balance_amount || "-"}
                  </span>
                </div>

                <div className="details-item">
                  <span className="details-label">Payable Amount</span>
                  <span className="details-value">
                    {personalDetails?.tax_amount || "-"}
                  </span>
                </div>
                
              </div>
            </div>
            <br />
            {/* <div className="borderWidth">
              <h5 className="m-3">Services Details</h5>
            </div> */}
            <div className="mt-3 m-3">
              {/* <div className="invoice-vechal-Details-SubView"> */}
              <table className="payment-invoice-table">
                {/* <thead>
                  <tr>
                    <th>Part Name</th>
                    <th>Qty</th>
                    <th>Price</th>
                    <th>Total Cost</th> 
                  </tr>
                </thead> */}
                <tfoot>
                  <tr>
                    <td colSpan={3}>Total</td>
                    <td> &#8377;{totalAmountValue || "-"}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Tax ({paybleTotalAmount?.Gst || "-"})</td>
                    <td> &#8377;{personalDetails?.tax_amount || "-"}</td>
                  </tr>
                  <tr>
                    <td colSpan={3}>Total Payable Amount</td>
                    <td> &#8377;{personalDetails?.balance_amount || "-"}</td>
                  </tr>
                </tfoot>
              </table>
              {/* <footer className="invoice-footer">
          <div className="pminfo"></div>
          <div className="total">
            <div className="totalval">
              
              <span>Subtotal:</span>
              <span>&#8377;{'5000' ||'-'}</span>
            </div>
            <div className="totalval">
              <span>Tax ({'18'}):</span> <span>&#8377;{Number('4000').toFixed(2) || '0'}</span>
            </div>
            <div className="grandtotal">
              <span>Grand Total: </span>
              <span>&#8377;{ Number('5000').toFixed(2) || '0'}</span>
            </div>
          </div>
        </footer> */}
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className="col-6">
          <div className="addButtonStyle m-3">
            <h5>Payment History</h5>
          </div>
          <div className="issue-list-parent-container">
            <table className="payment-invoice-table">
              <thead>
                <tr>
                  <th>Payment Mode</th>
                  <th>Tran. No.</th>
                  <th>Tran. Date</th>
                  {/* <th>Invoice Code</th> */}
                  <th>Tran. Amount</th>
                </tr>
              </thead>
              <tbody>
              {(paymentHistory || []).map((paymentHistory, index) => (
                <tr>
                  <td className="text">
                    {paymentHistory?.payment_mode || "-"}
                  </td>
                  <td className="text">
                    {paymentHistory?.transaction_number || "-"}
                  </td>
                  <td className="text">
                    {paymentHistory?.transaction_date}
                  </td>
                  {/* <td className="text">
                    {paymentHistory?.invoice_code}
                  </td> */}
                  <td className="price">
                    &#8377; {paymentHistory?.transaction_amount || "-"}
                  </td>
                </tr>
               ))} 
            </tbody>
              <tfoot>
                <tr>
                  <td className="textleft">Sub Total - {totalAmountVal || '-'} </td>
                  {/* <td className="textleft">{totalAmountVal || '-'}</td> */}
                  <td className="textleft">Pending Amt. - {pendingAmount  || "-"}</td>
                    {/* <td className="textleft"> &#8377;{pendingAmount  || "-"}</td> */}
                    <td colSpan={3}>Total Amount - {totalTransAmount || "-"}</td>
                    {/* <td> &#8377;{totalTransAmount || "-"}</td> */}
                </tr>


                
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <Offcanvas placement={"end"} show={UpdateModel} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {"Add Payment Details"}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="col-lg-12">

          <SalesDynamicForm
              formConfig={IssueInputs.map((input) => {
                if (input.name === "receiptFile") {
                  // Conditionally set visibility of receiptFile based on Payment_mode
                  return {
                    ...input,
                    isVisible: formData.Payment_mode !== 1, // Hide if Payment_mode is Cash (value = 1)
                  };
                }

                if (input.name === "deliverydate" || input.name === "deliveryremark") {
                  // Conditionally show delivery fields based on transaction amount matching pendingAmount
                  return {
                    ...input,
                    isVisible: showParentDesignation, // showParentDesignation controls visibility
                  };
                }

                return input;
              })}
              formData={formData}
              setFormData={setFormData}
              onSubmit={handleFormSubmit}
              validationErrors={validationErrors}
              setValidationErrors={setValidationErrors}
            />



            <div className="col-12 ">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn w-100"
              >
                {"Submit"}
              </button>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default InvoiceDetails;
